<template>
  <div class="loader" :class="layout? `loader-`+layout:''">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: ["layout"]
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.loader {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 6px solid $purple;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: $purple transparent transparent transparent;

    &:nth-child(1) {
      animation-delay: -0.45s;
    }
    &:nth-child(2) {
      animation-delay: -0.3s;
    }
    &:nth-child(3) {
      animation-delay: -0.15s;
    }
  }

  &-small {
    width: 40px;
    height: 40px;

    div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 28px;
      height: 28px;
      margin: 6px;
      border: 4px solid $purple;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: $purple transparent transparent transparent;

      &:nth-child(1) {
        animation-delay: -0.45s;
      }
      &:nth-child(2) {
        animation-delay: -0.3s;
      }
      &:nth-child(3) {
        animation-delay: -0.15s;
      }
    }

    &.white {
      div {
        border: 4px solid $green-2;
        border-color: $white transparent transparent transparent;
      }
    }
  }
  &-mini {
    width: 30px;
    height: 20px;
    margin-top: -11px;
    margin-left: -10px;
    margin-right: 3px;

    div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 20px;
      height: 20px;
      margin: 6px;
      border: 2px solid $purple;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: $purple transparent transparent transparent;

      &:nth-child(1) {
        animation-delay: -0.45s;
      }
      &:nth-child(2) {
        animation-delay: -0.3s;
      }
      &:nth-child(3) {
        animation-delay: -0.15s;
      }
    }

    &.white {
      div {
        border: 2px solid $green-2;
        border-color: $white transparent transparent transparent;
      
      }
    }
  }
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
